import axios from 'axios';

export const aiTransformService = {
    transformRichText: (sourceText, instruction) =>
        axios.post('/notes/ai/transform', { sourceText, instruction }, { auth: true }),
};
